import React from 'react';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
}

export const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  label,
  disabled = false,
}) => {
  return (
    <label className={`flex items-center gap-3 ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}>
      {label && <span className="text-sm font-medium">{label}</span>}
      <div className="relative inline-block w-11 h-6">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => !disabled && onChange(e.target.checked)}
          disabled={disabled}
          className="sr-only"
        />
        <div
          className={`absolute inset-0 rounded-full transition-all duration-300 ${
            disabled
              ? 'bg-gray-800 border border-gray-700'
              : checked
              ? 'bg-gradient-to-r from-ios-green to-green-500 shadow-lg shadow-ios-green/40'
              : 'bg-gray-700 border border-gray-600'
          }`}
        />
        <div
          className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full transition-transform duration-300 shadow-md ${
            checked ? 'transform translate-x-5' : ''
          } ${disabled ? 'opacity-50' : ''}`}
        />
      </div>
    </label>
  );
};

